import React, { Fragment, useState } from "react";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import Collapse from "@mui/material/Collapse";
import { Link } from "react-router-dom";

interface SubMenuItem {
  id: number;
  title: string;
  link: string;
}

interface MenuItem {
  id: number;
  title: string;
  link: string;
  submenu?: SubMenuItem[];
}

//  Menu data
const menus: MenuItem[] = [
  {
    id: 1,
    title: "Home",
    link: "/home",
    submenu: [
    /*   { id: 11, title: "Wedding Home Style 1", link: "/home" },
      { id: 12, title: "Wedding Home Style 2", link: "/home-2" },
      { id: 13, title: "Wedding Home Style 3", link: "/home-3" },
      { id: 14, title: "Wedding Planner Style 1", link: "/home-4" },
      { id: 15, title: "Wedding Planner Style 2", link: "/home-5" },
      { id: 16, title: "Wedding Shop Home", link: "/home-6" }, */
      { id: 17, title: "Wedding Invitation", link: "/invitation" },
    ],
  },
  {
    id: 2,
    title: "Pages",
    link: "/",
    submenu: [
      { id: 255, title: "Gallery", link: "/gallery" },
      { id: 29, title: "Coming Soon", link: "/coming" },
    ],
  },
  /* {
    id: 2,
    title: "Pages",
    link: "/",
    submenu: [
      { id: 21, title: "About", link: "/about" },
      { id: 22, title: "Our Story", link: "/story" },
      { id: 2201, title: "Our Story Style 1", link: "/story" },
      { id: 2202, title: "Our Story Style 2", link: "/story-2" },
      { id: 2203, title: "Our Story Style 3", link: "/story-3" },
      { id: 23, title: "Accomodation", link: "/accomodation" },
      { id: 24, title: "RSVP", link: "/rsvp" },
      { id: 2401, title: "RSVP Style 1", link: "/rsvp" },
      { id: 2402, title: "RSVP Style 2", link: "/rsvp-2" },
      { id: 2403, title: "RSVP Style 3", link: "/rsvp-3" },
      { id: 255, title: "Gallery", link: "/gallery" },
      { id: 266, title: "Planners", link: "/planner" },
      { id: 258, title: "Planner Single", link: "/team-single/Jenny-Wilson" },
      { id: 267, title: "Bridesmaid & Groomsman", link: "/groom-bride" },
      { id: 253, title: "Service", link: "/service" },
      { id: 2531, title: "Service Style 1", link: "/service" },
      { id: 2532, title: "Service Single", link: "/service-single/Wedding-Dress" },
      { id: 28, title: "Pricing", link: "/pricing" },
      { id: 290, title: "Auth Pages", link: "/" },
      { id: 2901, title: "Login", link: "/login" },
      { id: 2902, title: "Register", link: "/register" },
      { id: 2903, title: "Forgot Password", link: "/forgot" },
      { id: 29, title: "Coming Soon", link: "/coming" },
      { id: 221, title: "404 Error", link: "/404" },
    ],
  },
  {
    id: 4,
    title: "Portfolio",
    link: "/portfolio-grid",
    submenu: [
      { id: 41, title: "Portfolio Grid", link: "/portfolio-grid" },
      { id: 421, title: "Portfolio Grid S2", link: "/portfolio-grid-s2" },
      { id: 422, title: "Portfolio Slide", link: "/portfolio-slide" },
      { id: 42, title: "Portfolio Masonary", link: "/portfolio-masonary" },
      { id: 44, title: "Portfolio Single", link: "/project-single/James-Amelia" },
    ],
  },
  {
    id: 7,
    title: "Shop",
    link: "/shop",
    submenu: [
      { id: 71, title: "Shop", link: "/shop" },
      { id: 75, title: "Shop Single", link: "/product-single/Stylish-Designer-Gown" },
      { id: 76, title: "Cart", link: "/cart" },
      { id: 77, title: "Wishlist", link: "/wishlist" },
      { id: 78, title: "Checkout", link: "/checkout" },
    ],
  },
  {
    id: 5,
    title: "Blog",
    link: "/blog",
    submenu: [
      { id: 51, title: "Blog", link: "/blog" },
      { id: 52, title: "Blog Left sidebar", link: "/blog-left" },
      { id: 53, title: "Blog full width", link: "/blog-fullwidth" },
      { id: 54, title: "Blog single", link: "/blog-single/You-Must-Need-a-Great-Photographer" },
      { id: 55, title: "Blog single Left sidebar", link: "/blog-single-left-sidebar/You-Must-Need-a-Great-Photographer" },
      { id: 56, title: "Blog single Fullwidth", link: "/blog-single-fullwidth/You-Must-Need-a-Great-Photographer" },
    ],
  },
  {
    id: 88,
    title: "Contact",
    link: "/contact",
  }, */
];

// Mobile Menu Component
const MobileMenu: React.FC = () => {
  const [openId, setOpenId] = useState<number>(0);
  const [menuActive, setMenuActive] = useState<boolean>(false);

  const handleScrollTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  return (
    <div>
      <div className={`mobileMenu ${menuActive ? "show" : ""}`}>
        <div className="menu-close">
          <div className="clox" onClick={() => setMenuActive(false)}>
            <i className="ti-close"></i>
          </div>
        </div>

        <ul className="responsivemenu">
          {menus.map((item) => (
            <ListItem
              key={item.id}
              className={item.id === openId ? "active" : ""}
            >
              {item.submenu ? (
                <Fragment>
                  <p
                    onClick={() =>
                      setOpenId(item.id === openId ? 0 : item.id)
                    }
                  >
                    {item.title}
                    <i
                      className={
                        item.id === openId
                          ? "fa fa-angle-up"
                          : "fa fa-angle-down"
                      }
                    ></i>
                  </p>

                  <Collapse
                    in={item.id === openId}
                    timeout="auto"
                    unmountOnExit
                  >
                    <List className="subMenu">
                      {item.submenu.map((submenu) => (
                        <ListItem key={submenu.id}>
                          <Link
                            onClick={() => {
                              handleScrollTop();
                              setMenuActive(false);
                            }}
                            to={submenu.link}
                          >
                            {submenu.title}
                          </Link>
                        </ListItem>
                      ))}
                    </List>
                  </Collapse>
                </Fragment>
              ) : (
                <Link
                  onClick={() => {
                    handleScrollTop();
                    setMenuActive(false);
                  }}
                  to={item.link}
                >
                  {item.title}
                </Link>
              )}
            </ListItem>
          ))}
        </ul>
      </div>

      <div className="showmenu" onClick={() => setMenuActive(!menuActive)}>
        <button type="button" className="navbar-toggler open-btn">
          <span className="icon-bar first-angle"></span>
          <span className="icon-bar middle-angle"></span>
          <span className="icon-bar last-angle"></span>
        </button>
      </div>
    </div>
  );
};

export default MobileMenu;
